import Activity from './Activity';

// Export the Activity component which contains tabs (Communications, Notes)
export default Activity;
